import React from 'react'
import { redirect } from 'react-router-dom'

import { PerformanceV2TabsDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { buildModuleRoute, buildNavigation } from 'modules/core/lib/react-router'

import { competenciesRoutes } from 'modules/competencies/routes'
import { goalsRoutes } from 'modules/goals/routes'
import { performanceOneOnOnesRoutes } from 'modules/one_on_ones/routes'
import { performanceCyclesRoutes } from 'modules/performance_cycles/routes'
import { performanceFeedbacksRoutes } from 'modules/performance_feedbacks/routes'
import { performanceProcessRoutes } from 'modules/performance_process/routes'
import { getModuleActiveFeatures } from 'modules/performance_v2/lib/getModuleFeatures'

const RedirectToRoutePage = React.lazy(
  () => import('modules/performance_v2/pages/RedirectToRoutePage')
)
const RootPage = React.lazy(() => import('modules/performance_v2/pages/RootPage'))

export const performanceV2Routes = buildNavigation((navigation) => [
  buildModuleRoute({
    path: navigation.performanceProcess.path,
    element: <RootPage />,
    handle: {
      module: 'performance_v2',
      moduleName: () => i18n.t('sidebar.performance_new'),
      meta: ({ watchQuery }) => {
        return watchQuery({
          query: PerformanceV2TabsDocument,
        }).map(({ data }) => {
          const { features } = getModuleActiveFeatures(
            {
              hasReviewProcess:
                data?.performance?._policies?.sidebarSeePerformanceReviewProcessSubLevelItem?.can,
              hasGoalsV2: data?.goals._policies?.sidebarSeePerformanceGoalsV2SubLevelItem?.can,
              hasOneOnOnes:
                data?.oneOnOnes._policies?.sidebarSeePerformanceOneOnOnesSubLevelItem?.can,
              hasFeedbacks:
                data?.feedbacks._policies?.sidebarSeePerformanceFeedbacksSubLevelItem?.can,
              hasCycles:
                data?.performanceCycles._policies?.sidebarSeePerformanceCyclesSubLevelItem?.can,
              hasCompetencies:
                data?.competencies?._policies?.sidebarSeePerformanceCompetenciesSubLevelItem?.can ??
                false,
            },
            navigation
          )

          return {
            title: i18n.t('sidebar.performance_new'),
            subNavigation: features.map((feature) => ({
              title: feature.name,
              href: feature.path,
              id: feature.path,
              isVisible: feature.isVisible,
            })),
          }
        })
      },
    },
    children: [
      {
        index: true,
        element: <RedirectToRoutePage />,
      },
      ...performanceProcessRoutes(navigation),
      ...goalsRoutes(navigation),
      ...performanceOneOnOnesRoutes(navigation),
      ...performanceFeedbacksRoutes(navigation),
      ...performanceCyclesRoutes(navigation),
      ...competenciesRoutes(navigation),
    ],
  }),
  // TODO: remove this redirects routes later, added here because the routes must exists to be redirected
  {
    path: navigation.competencies.path.replace(`${navigation.performanceProcess.path}/`, ''),
    loader: () => redirect(navigation.competencies.fullPath()),
    children: [
      {
        path: navigation.competencies.groups.path.replace(
          `${navigation.performanceProcess.path}/`,
          ''
        ),
        loader: () => redirect(navigation.competencies.groups.fullPath()),
      },
      {
        path: navigation.competencies.competencyId.path.replace(
          `${navigation.performanceProcess.path}/`,
          ''
        ),
        loader: ({ params }) =>
          redirect(
            navigation.competencies.competencyId.settings.fullPath({
              competencyId: Number(params.competencyId),
            })
          ),
        children: [
          {
            path: navigation.competencies.competencyId.settings.path.replace(
              `${navigation.performanceProcess.path}/`,
              ''
            ),
          },
        ],
      },
    ],
  },
])
